import React from "react";
import PropTypes from "prop-types";

const scopeLabels = {
  all: "All items", all_services: "All services", all_products: "All products",
  service: "Service", product: "Product", membership: "Package",
  subscription: "Subscription", brand: "Brand",
};

export default function SubscriptionDiscountCodeBenefits({ terms }) {
  if (terms?.agreement_status !== "recorded" || terms?.discount_codes_status !== "recorded") {
    return <div>Discount-code benefits were not recorded for this historical purchase.</div>;
  }
  const codes = Array.isArray(terms.discount_codes) ? terms.discount_codes : [];
  if (!codes.length) return null;
  return <section className="subscription-discount-code-benefits">
    <div>Purchased discount-code benefits</div>
    <div>These are purchased benefit definitions; availability is checked when a code is used.</div>
    <ul>{codes.map(code => {
      const combined = [["allow_with_package", "Packages"], ["allow_with_subscription", "Subscriptions"], ["allow_with_voucher", "Vouchers"]]
        .filter(([key]) => code[key] === true).map(([, label]) => label);
      const amount = code.discount_type === "percentage"
        ? `${Number(code.value)}%`
        : `${terms.currency} ${Number(code.value).toFixed(2)}`;
      return <li key={code.id}>
        <div>{code.code} · {amount} discount</div>
        <div>Valid from: {code.valid_from || "No start restriction"} · Valid until: {code.valid_until || "No expiry restriction"}</div>
        <div>Total use limit: {code.total_use_limit ?? "Unlimited"} · Per-client use limit: {code.per_client_use_limit ?? "Unlimited"}</div>
        <div>Can combine with: {combined.join(", ") || "None"}</div>
        <div>{code.is_active ? "Active at purchase" : "Inactive at purchase"}</div>
        {code.scopes?.length ? <ul>{code.scopes.map((scope, index) => <li key={index}>
          {scope.is_excluded ? "Excluded scope" : "Included scope"}: {scopeLabels[scope.scope_type] || "Scope unavailable"}
          {scope.target_id != null && ` · ${scope.name || `#${scope.target_id} (name unavailable)`}`}
        </li>)}</ul> : <div>Scope details were not recorded.</div>}
      </li>;
    })}</ul>
  </section>;
}

SubscriptionDiscountCodeBenefits.propTypes = { terms: PropTypes.object };
